import { render, staticRenderFns } from "./BindPaper.vue?vue&type=template&id=f97a8dbe&scoped=true"
import script from "./BindPaper.vue?vue&type=script&lang=js"
export * from "./BindPaper.vue?vue&type=script&lang=js"
import style0 from "./BindPaper.vue?vue&type=style&index=0&id=f97a8dbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97a8dbe",
  null
  
)

export default component.exports